import reactComponentLoader from 'scripts/react-component-loader'

import { Success } from './pages/Success'

reactComponentLoader(Success, '[data-success-page]')
